export const Footer = () => {
  return (
    <footer
      className="relative py-12 md:py-16 border-t border-[#EDD9DE] bg-[#FAF3F2]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="font-serif text-2xl font-light text-[#3B2630] tracking-tight">
            J Muenz<span className="text-[#C9587E]">.</span>
          </div>
          <p className="font-body text-xs uppercase tracking-[0.25em] text-[#97808A] text-center">
            The Goldmine &middot; Six Months of Voice Note Mentorship
          </p>
          <p className="font-body text-xs text-[#97808A]">
            &copy; {new Date().getFullYear()} J Muenz. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
